import { fetchAllAssets } from 'services/market.service';
import { getNftOfTheDayService } from 'services/nft-of-the-day.service';

import {
  FETCH_NFT_OF_THE_DAY,
  FETCH_NFT_OF_THE_DAY_ASSETS,
  REFRESH_NFT_OF_THE_DAY_UPDATE_TOKEN,
  RESET_NFT_OF_THE_DAY_DATA,
} from './actionNames/nftOfTheDayActionNames';

export const resetNftOfTheDayDataAction = () => ({ type: RESET_NFT_OF_THE_DAY_DATA });

export const refreshNftOfTheDayUpdateTokenAction = () => ({ type: REFRESH_NFT_OF_THE_DAY_UPDATE_TOKEN });

export const fetchNftOfTheDayAction = (signal: AbortSignal) => ({
  type: FETCH_NFT_OF_THE_DAY,
  payload: getNftOfTheDayService(signal),
});

export const fetchNftOfTheDayAssetsAction = (assetIds: number[]) => ({
  type: FETCH_NFT_OF_THE_DAY_ASSETS,
  payload: fetchAllAssets(assetIds),
});
